import type { ReactNode } from 'react';
import { Badge } from '@/shared/ui/badge';
import type { BadgeTone } from '@/shared/ui/badge';
import type { SaveOutcome } from '@/modules/catalog/pages/setup-page/types';

/**
 * The outcome of ONE saved item.
 *
 * ---------------------------------------------------------------------------
 * A REFUSAL IS SHOWN, NEVER SWALLOWED
 * ---------------------------------------------------------------------------
 * A duplicate slug, a duplicate attribute key, a refused parent — each of them
 * lands on the item that caused it, in the API's own vocabulary. An item that
 * failed is not silently skipped: the merchant sees which one failed and why,
 * and the others still saved.
 */
const TONE_BY_STATUS: Record<SaveOutcome['status'], BadgeTone> = {
  created: 'positive',
  refused: 'critical',
  'created-not-assigned': 'caution',
};

const LABEL_BY_STATUS: Record<SaveOutcome['status'], string> = {
  created: 'Created',
  refused: 'Not created',
  'created-not-assigned': 'Created, not attached',
};

export function OutcomeLine({ outcome }: { outcome: SaveOutcome | null }): ReactNode {
  if (outcome === null) return null;
  return (
    <p className="flex flex-wrap items-center gap-2 text-sm">
      <Badge tone={TONE_BY_STATUS[outcome.status]}>{LABEL_BY_STATUS[outcome.status]}</Badge>
      <span className="text-content-muted">{outcome.message}</span>
    </p>
  );
}
